import { createContext, useState } from "react";

export const MovieIndexContext = createContext();

const MovieIndexContextProvider = ({ children }) => {
  const [movieIndex, setMovieIndex] = useState();
  const [movieId, setMovieId] = useState(0);
  const [loading, setLoading] = useState(false);

  const changeEventHandler = (selectedMovieId) => {
    setMovieId(selectedMovieId.activeIndex);

    // console.log(selectedMovieId.activeIndex);
  };
  return (
    <>
      <MovieIndexContext.Provider
        value={{
          movieIndex,
          setMovieIndex,
          movieId,
          setMovieId,
          changeEvent: changeEventHandler,
          loading,
          setLoading,
        }}
      >
        {children}
      </MovieIndexContext.Provider>
    </>
  );
};

export default MovieIndexContextProvider;
